import { Modal } from "@mui/material";
import { useState } from "react";
import "../../../assets/styles/registrationRequest/registrationRequest.scss";
import RegistrationRequestModal from "./RegistrationRequestModal";
import { LeadType } from "types/leadType";

interface Props {
    promotionModalOpen: boolean;
    leadType: LeadType;
    secureId: string;
    requestNumber: string;
    productName: string;
    setPromotionModal: (open: boolean) => void;
    onEmailSend(): void;
    onEmailError(): void;
}
/**
 * Pre-Registration promotion popup
 */
function Promotion({
    promotionModalOpen,
    leadType,
    secureId,
    requestNumber,
    productName,
    setPromotionModal,
    onEmailSend,
    onEmailError
}: Readonly<Props>) {
    const [confirmationModel, setConfirmationModel] = useState<boolean>(false);

    function click() {
        setConfirmationModel(true);
        setPromotionModal(false);
    }

    return (
        <div>
            <Modal
                className="promotion-popup-container"
                open={promotionModalOpen}
                aria-labelledby="acquired-popup"
                aria-describedby="acquired-popup-information"
            >
                <div className="promotion-popup-modal-body">
                    <div
                        className="icon icon-close"
                        onClick={() => setPromotionModal(false)}
                    ></div>
                    <h2 id="pre-lunch-registration-popup-title">
                        Kundengewinnung: Nutzen Sie bereits die Chancen der
                        Digitalisierung?
                    </h2>
                    <p className="mtb-30 mr-10-desktop">
                        Steigen Sie mit dem <strong>Anfragen-Manager</strong> in
                        die digitale Kundengewinnung ein.
                        <br />
                        <strong>Einfach, effizient</strong> und{" "}
                        <strong>zukunftsorientiert!</strong>
                    </p>
                    <div className="promotion-popup-body">
                        <div className="promotion-popup-message-box">
                            <h3>Ihre Vorteile</h3>
                            <ul className="am-promotion-list">
                                <li>
                                    <i className="icons-check color-dark-green"></i>{" "}
                                    Klinik- & Privatanfragen zentral verwalten
                                </li>
                                <li>
                                    <i className="icons-check color-dark-green"></i>{" "}
                                    Kapazitäten mit passenden Anfragen auslasten
                                </li>
                                <li>
                                    <i className="icons-check color-dark-green"></i>{" "}
                                    Der zentrale Ansprechpartner der Region
                                    werden
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="button-container">
                        <button className="btn mobile-button" onClick={click}>
                            Mehr erfahren
                        </button>
                    </div>
                </div>
            </Modal>

            <RegistrationRequestModal
                popupOpen={confirmationModel}
                leadType={leadType}
                secureId={secureId}
                requestNumber={requestNumber}
                productName={productName}
                setPopupOpen={setConfirmationModel}
                onEmailSend={() => onEmailSend()}
                onEmailError={() => onEmailError()}
            ></RegistrationRequestModal>
        </div>
    );
}

export default Promotion;
